export const OVERRIDE_DIALOG_TITLE = 'Override validation';

export const OVERRIDE_DIALOG_DESCRIPTION = 'An internal note will record the reason and who turned the override on.';

export const OVERRIDE_CONFIRM_LABEL = 'Confirm';
